import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, inject, signal } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { loadScript } from '../../../lib/load-script';
import { sleep } from '../../../lib/sleep';
import { EmbedService } from '../../../services/embed.service';
import { EmbedType } from '../../../types/embed.type';

@Component({
  selector: 'app-embed-display',
  templateUrl: './embed-display.component.html',
  styleUrls: ['./embed-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class EmbedDisplayComponent implements OnInit, OnChanges {
  private sanitizer = inject(DomSanitizer);
  private embedService = inject(EmbedService);
  @Input() url: URL;
  embedUrl = signal<SafeUrl>(undefined);
  embedUrlString = signal<string>(undefined);
  type = signal<EmbedType>(undefined);

  ngOnInit(): void {
    this.setup();
  }

  ngOnChanges(): void {
    this.setup();
  }

  setup() {
    if (!this.url) {
      this.type.set(undefined);
      this.embedUrl.set(undefined);
      this.embedUrlString.set(undefined);
      return;
    }
    const type = this.embedService.types.find(_type => _type.regex.test(this.url.host + this.url.pathname));
    if (type) {
      this.type.set(type);
      this.embedUrlString.set(this.embedService.getEmbedUrl(this.type(), this.url));
      this.embedUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(this.embedUrlString()));
    }
    this.loadAnyScripts();
  }

  async loadAnyScripts() {
    if (this.type()?.name === 'twitter')
      await loadScript('https://platform.twitter.com/widgets.js', { ignoreErrors: true });
    if (this.type()?.name === 'instagram') {
      await loadScript('https://www.instagram.com/embed.js', { ignoreErrors: true });
      await sleep(0);
      window['instgrm']?.Embeds?.process();
    }
  }
}
